<template>
    <div class="animated fadeIn">
        <Tables
            ref="tableGrid"
            :columns="['NOME DO GRUPO', 'AÇÕES']"
            :showNew="true"
            :showReload="true"
            :showSearch="true"
            :showTipFooter="false"
            v-on:Search="onShowSearch"
            v-on:New="onNew"
            v-on:Load="onLoad"
            v-on:Reload="onLoad"
        >
            <tr v-for="obj in this.objList" v-bind:key="obj.id">
                <TableColumn
                    :IsText="true"
                    v-on:Edit="onEdit(obj)"
                    :status="obj.inative ? 0 : 1"
                    :value="obj && obj.nameGroup ? obj.nameGroup.toUpperCase() : ''"
                />
                <td class="row justify-content-around">
                    <div v-if="obj.inative">
                        <b-dropdown variant="link" size="sm" no-caret>
                            <template slot="button-content">
                                <i
                                    class="fa fa-lock-open cursor-pointer"
                                    style="color: black;"
                                    :title="$lang.GroupsConfig.UnlockGroupToolTip"
                                ></i>
                            </template>
                            <b-dropdown-header><strong>{{ $lang.GroupsConfig.ConfirmUnlockGroup }}</strong></b-dropdown-header>
                            <b-dropdown-item
                                href="javascript:void(0);"
                                v-on:click="changeGroupStatus(obj, 'false')"
                            >
                                {{ $lang.Common.Yes }}
                            </b-dropdown-item>
                            <b-dropdown-item
                                href="javascript:void(0);"
                            >
                                {{ $lang.Common.No }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <div v-if="!obj.inative">
                        <b-dropdown variant="link" size="sm" no-caret>
                            <template slot="button-content">
                                <i
                                    class="fas fa-ban text-third cursor-pointer"
                                    style="color: red;"
                                    :title="$lang.GroupsConfig.BlockGroupToolTip"
                                ></i>
                            </template>
                            <b-dropdown-header>
                                <strong>{{ $lang.GroupsConfig.ConfirmBlockGroup }}</strong>
                            </b-dropdown-header>
                            <b-dropdown-item
                                href="javascript:void(0);"
                                v-on:click="changeGroupStatus(obj, 'true')"
                            >
                                {{ $lang.Common.Yes }}
                            </b-dropdown-item>
                            <b-dropdown-item
                                href="javascript:void(0);"
                            >
                                {{ $lang.Common.No }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </td>
            </tr>
        </Tables>
        <div class="row">
            <div class="col-12 pb-3 pl-4">
                <button
                    type="button"
                    class="btn btn-third btn-sm"
                    v-on:click="$emit('New')"
                    v-b-tooltip.hover
                    :title="'Clique para cadastrar'"
                >
                    <i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo Usuário</span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import GroupRepository from '@/shared/http/repositories/configurations/group.js'
import GroupSearchScreen from '../search/search.vue'
import { advancedOnException } from '@/components/tools/Utils'

export default {
  name: 'GroupList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  methods: {
    onNew () {
      this.$emit('New')
    },
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    changeGroupStatus (obj, status) {
      loading.push()
      let data = {
        inative: status
      }
      GroupRepository.ChangeStatus(obj.id, data)
        .then(() => {
          this.onLoadAll()
          loading.pop()
        })
        .catch(e => advancedOnException(e, this.$lang))
    },
    onLoadAll () {
      loading.push()
      if (this.filters && this.filters.nameGroup) {
        GroupRepository.Search(this.filters.nameGroup, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        GroupRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onShowSearch () {
      let aside = {
        title: 'Pesquisar',
        self: this,
        component: GroupSearchScreen
      }
      this.$eventHub.emit('Search', aside)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/group/components/list/grouplist.vue